mobileSize = 1024;

// Ticket Button
function placeTicketButton() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.ticket').appendTo('.header-bottom');
  } else {
    $('.ticket').insertAfter('.quick-links');
  }
}

// Countdown
function placeCountdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').appendTo('.tier-one');
  } else {
    $('#siteInfoBannerWidget').prependTo('.header-top-left');
  }
}

// Social Network Sidebar
function placeSocialSidebar() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.socialNetworks').appendTo('footer');
  } else {
    $('.socialNetworks').appendTo('#uc_masterPageWidgets');
  }
}

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1025) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1024) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Ticket Button
  placeTicketButton();

  // Countdown
  placeCountdown();

  // Social Network Sidebar
  placeSocialSidebar();

  // Dynamic Hero
  var heroHTML = '<div class="hero-wrapper" style="background-image: url()"></div>';

  function dynamicHero() {
    var image = $('.entityContainer .entityContainerRow.rowIndex-1').find('.TextMediaModule .single-photo img').attr('data-src');
    var imageSrc = image.replace(/(?=[() ])/g, '\\');
    $('.hero-wrapper').css('background-image', 'url(' + imageSrc + ')');
  }

  if ($('body').hasClass('custom')) {
    $(heroHTML).prependTo('.wrapper');
    dynamicHero();
  }

});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');

  // Weather Bug
  setInterval(function() {
		var str = $('#weatherBugDescription').text();
		var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
		if(!weatherBugSet && str != ''){
			$('#weatherBugWidget').addClass('weatherBugSet');
		    var findSpace = str.lastIndexOf(' ');
		    var stringLength = str.length;
		    var res = str.substring(findSpace, stringLength);
		    var start = str.substring(0, findSpace);
		    $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
		    $('#weatherBugWidget').css('visibility', 'visible');
		}
	},12);

  // Footer Navigation
  $('.saffireMobileSize .footerItems1 li a').removeClass('button');
});

$(window).resize(function(){
  // Ticket Button
  placeTicketButton();

  // Countdown
  placeCountdown();

  // Social Network Sidebar
  placeSocialSidebar();

  // Footer Navigation
  $('.saffireMobileSize .footerItems1 li a').removeClass('button');
});